import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { NotificationContextDefaults } from 'common/constants/notificationContextDefaults';
import SavedEmailStatusEnum from 'common/constants/SavedEmailStatusEnum';
import AnnouncementsService from '@services/announcements.service';
import { timeZonesAdapter } from 'utils/timeZonesAdapter';
import configService from '@services/config.service';
const NotificationContext = createContext(NotificationContextDefaults);
export const useNotificationContext = () => useContext(NotificationContext);
const { ControlCenterApiUrl } = configService;
const announcementsService = new AnnouncementsService(ControlCenterApiUrl);
const NotificationProvider = ({ children }) => {
    const [announcements, setAnnouncements] = useState([]);
    const [unreadCount, setUnreadCount] = useState(0);
    const [emailAddresses, setEmailAddresses] = useState([]);
    const [isEmailSaved, setIsEmailSaved] = useState(SavedEmailStatusEnum.NONE);
    const [userTimeZone, setUserTimeZone] = useState({});
    const getUserAnnouncements = useCallback(async (userUuid = '') => {
        if (userUuid) {
            const result = await announcementsService.getUserAnnouncements(userUuid);
            const { items = [], totalCount = 0 } = result || {};
            setUnreadCount(totalCount);
            setAnnouncements(items);
        }
    }, []);
    const getEmails = useCallback(async (userUuid = '') => {
        if (userUuid) {
            const emailResult = await announcementsService.getAnnouncementEmails(userUuid);
            const { data: { addresses = [] } = {} } = emailResult;
            setEmailAddresses(addresses);
        }
    }, []);
    const getTimeZone = useCallback(async () => {
        const timeZoneResult = await announcementsService.getTimeZone();
        const { userTimeZone } = timeZonesAdapter(timeZoneResult);
        setUserTimeZone(userTimeZone);
    }, []);
    const saveEmailAddress = useCallback(async (userUuid = '', updatedEmailAddresses = []) => {
        try {
            await announcementsService.updateAnnouncementEmails(userUuid, updatedEmailAddresses);
            setIsEmailSaved(SavedEmailStatusEnum.SUCCESS);
            setEmailAddresses(updatedEmailAddresses);
        }
        catch {
            setIsEmailSaved(SavedEmailStatusEnum.ERROR);
        }
    }, []);
    const values = useMemo(() => ({
        announcements,
        getUserAnnouncements,
        unreadCount,
        emailAddresses,
        getEmails,
        saveEmailAddress,
        setIsEmailSaved,
        isEmailSaved,
        getTimeZone,
        userTimeZone,
    }), [
        announcements,
        getUserAnnouncements,
        unreadCount,
        emailAddresses,
        getEmails,
        saveEmailAddress,
        isEmailSaved,
        getTimeZone,
        userTimeZone,
    ]);
    return (<NotificationContext.Provider value={values}>
            <>{children}</>
        </NotificationContext.Provider>);
};
export default NotificationProvider;
